export const languagesTranslation = {
  es: 'shared.languages.es',
  en: 'shared.languages.en',
  ca: 'shared.languages.ca',
}

export const formTranslation = {
  common: {
    requiredFields: 'shared.forms.required_fields',
    import: 'shared.forms.import',
    validationBlockMessage: 'shared.forms.common.validationBlockMessage',
    retryBlockMessage: 'shared.forms.common.retryBlockMessage',
    buttons: {
      accept: 'shared.forms.buttons.accept',
      cancel: 'shared.forms.buttons.cancel',
      save: 'shared.forms.buttons.save',
      saveAndContinue: 'shared.forms.buttons.save_and_continue',
      continue: 'shared.forms.buttons.continue',
      delete: 'shared.forms.buttons.delete',
      confirm: 'shared.forms.buttons.confirm',
      add: 'shared.forms.buttons.add',
      back: 'shared.forms.buttons.back',
      understood: 'shared.forms.buttons.understood',
      tryAgain: 'shared.forms.buttons.tryAgain',
      accessToWeb: 'shared.forms.buttons.accessToWeb',
    },
    months: {
      january: 'forms.months.january',
      february: 'forms.months.february',
      march: 'forms.months.march',
      april: 'forms.months.april',
      may: 'forms.months.may',
      june: 'forms.months.june',
      july: 'forms.months.july',
      august: 'forms.months.august',
      september: 'forms.months.september',
      october: 'forms.months.october',
      november: 'forms.months.november',
      december: 'forms.months.december',
    },
    identifier: {
      name: {
        label: 'forms.identifier.name.label',
        placeholder: 'forms.identifier.name.placeholder',
      },
      firstSurname: {
        label: 'forms.identifier.firstSurname.label',
        placeholder: 'forms.identifier.firstSurname.placeholder',
      },
      secondSurname: {
        label: 'forms.identifier.secondSurname.label',
        placeholder: 'forms.identifier.secondSurname.placeholder',
      },
      documentType: {
        label: 'forms.identifier.documentType.label',
        placeholder: 'forms.identifier.documentType.placeholder',
        dni: 'forms.identifier.documentType.dni',
        passport: 'forms.identifier.documentType.passport',
        legend: 'forms.identifier.documentType.legend',
      },
      documentNumber: {
        label: 'forms.identifier.documentNumber.label',
        placeholder: 'forms.identifier.documentNumber.placeholder',
      },
      birthDate: {
        label: 'forms.identifier.birthDate.label',
        placeholder: 'forms.identifier.birthDate.placeholder',
      },
      phone: {
        label: 'forms.identifier.phone.label',
        placeholder: 'forms.identifier.phone.placeholder',
      },
      email: {
        label: 'forms.identifier.email.label',
        placeholder: 'forms.identifier.email.placeholder',
        legend: 'forms.identifier.email.legend',
        tooltip: 'forms.identifier.email.tooltip',
      },
      merchantId: {
        label: 'forms.identifier.affiliateCode.label',
        placeholder: 'forms.identifier.affiliateCode.placeholder',
        tooltip: 'forms.identifier.affiliateCode.tooltip',
      },
      legalId: {
        label: 'forms.identifier.cif.label',
        placeholder: 'forms.identifier.cif.placeholder',
        legend: 'forms.identifier.cif.legend',
      },
    },
    address: {
      address: 'forms.address.address',
      addressStreet: {
        label: 'forms.address.addressStreet.label',
        placeholder: 'forms.address.addressStreet.placeholder',
      },
      addressNumber: {
        label: 'forms.address.addressNumber.label',
        placeholder: 'forms.address.addressNumber.placeholder',
        legend: 'forms.address.addressNumber.legend',
      },
      addressExtra: {
        label: 'forms.address.addressExtra.label',
        placeholder: 'forms.address.addressExtra.placeholder',
      },
      addressPostalCode: {
        label: 'forms.address.addressPostalCode.label',
        placeholder: 'forms.address.addressPostalCode.placeholder',
      },
      addressCity: {
        label: 'forms.address.addressCity.label',
        placeholder: 'forms.address.addressCity.placeholder',
      },
      addressProvince: {
        label: 'forms.address.addressProvince.label',
        placeholder: 'forms.address.addressProvince.placeholder',
      },
    },
  },
  success: {
    message: 'forms.success.message',
  },
  errors: {
    wrongUserOrPass: 'forms.errors.wrongUserOrPass',
    fieldRequired: 'forms.errors.fieldRequired',
    fieldsRequired: 'forms.errors.fieldsRequired',
    invalidFormat: 'forms.errors.invalidFormat',
    noValidFormat: 'forms.errors.noValidFormat',
    invalidCode: 'forms.errors.invalidCode',
    invalidmerchantIdFormat: 'forms.errors.invalidAffiliateCodeFormat',
    invalidCifOrDni: 'forms.errors.invalidCifOrDni',
    privacyPolicy: 'forms.errors.privacyPolicy',
    phoneInvalid: 'forms.errors.phoneInvalid',
    mobilePhoneInvalid: 'forms.errors.mobilePhoneInvalid',
    passwordMatch: 'forms.errors.passwordMatch',
    passwordFormat: 'forms.errors.passwordFormat',
    emailMatch: 'forms.errors.emailMatch',
    emailMatchStep2: 'forms.errors.emailMatchStep2',
    nameNumbers:'forms.errors.nameNumbers',
    reviewErrors: 'forms.errors.reviewErrors',
    maxAllowed: 'forms.errors.maxAllowed',
    invalidDate: 'forms.errors.invalidDate',
    genericError: 'forms.errors.genericError',
    numberValue: 'forms.errors.numberValue',
    notZero: 'forms.errors.notZero',
    maxPercentge: 'forms.errors.maxPercentge',
    numberWithMax: 'forms.errors.numberWithMax',
    maxAge: 'forms.errors.maxAge',
    minAge: 'forms.errors.minAge',
    maxChars: 'forms.errors.maxChars',
    minChars: 'forms.errors.minChars',
    fieldMinChars: 'forms.errors.fieldMinChars',
    minDate: 'forms.errors.minDate',
    maxDate: 'forms.errors.maxDate',
    notInteger: 'forms.errors.notInteger',
    mustBeUnique: 'forms.errors.mustBeUnique',
    mustBeDiferent: 'forms.errors.mustBeDiferent',
    atLeastOne: 'forms.errors.atLeastOne',
    invalidPasswordFormat: 'forms.errors.invalidPasswordFormat',
    passwordsDoNotMatch: 'forms.errors.passwordsDoNotMatch',
    affiliateAlreadyHasAccount: 'forms.errors.affiliateAlreadyHasAccount',
    wrongUserOrPassword: 'forms.errors.wrongUserOrPassword',
    invalidEmailFormat: 'forms.errors.invalidEmailFormat',
  },
  buttons: {
    download: 'shared.buttons.download',
  },
}

export const tablePagination = {
  title: 'tablePagination.title',
  captionTitle: 'tablePagination.captionTitle',
  rowsTotalDescription: 'tablePagination.rowsTotalDescription',
  searchTitle: 'tablePagination.searchTitle',
  selectedRowsDescriptionOne: 'tablePagination.selectedRowsDescriptionOne',
  selectedRowsDescriptionOthers: 'tablePagination.selectedRowsDescriptionOthers',
  nextPageLabel: 'tablePagination.nextPageLabel',
  previousPageLabel: 'tablePagination.previousPageLabel',
  pageOf: 'tablePagination.pageOf',
  NextButtonLabel: 'tablePagination.NextButtonLabel',
  backButtonLabel: 'tablePagination.backButtonLabel',
  searchNotFoundFirst: 'tablePagination.searchNotFound.first',
  searchNotFoundLink: 'tablePagination.searchNotFound.link',
  searchNotFoundEnd: 'tablePagination.searchNotFound.end',
  rowsShowing: 'tablePagination.rowsShowing',
}

export const protectedProcessTranslation = {
  title: 'shared.protected.modal.title',
  description: 'shared.protected.modal.description',
}
